<template>
  <div class="progress progress-indicator" v-if="progressPercent">
    <div class="progress-bar" :style="{ width: progressPercent + '%', height: '5px'}"></div>
  </div>
</template>

<script>
export default {
  computed: {
    ...amfx.map('progress', 'progressPercent')
  },
}
</script>

<style scoped>
.progress {
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  width: 100%;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0;
}

.progress-bar {
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}

.progress-bar {
  background-color: #2c4583 !important;
}
</style>



// WEBPACK FOOTER //
// src/framework/primitives/ProgressBar.vue